// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3095":"bd983226","3410":"bd983226"}[chunkId] + ".chunk.css";
};